import { Injectable } from '@angular/core';
import { WatchQueryFetchPolicy } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DataService {

    private readonly context =  {
        headers: {},
    };

    constructor(private apollo: Apollo) { }

    query<T = any, V extends Record<string, any> = Record<string, unknown>>(query: DocumentNode, variables?: V, fetchPolicy?: WatchQueryFetchPolicy): Observable<T> {
        return this.apollo.watchQuery<T, V>({
            query,
            variables: this.omitSkipTotalCount(variables),
            context: this.context,
            fetchPolicy: fetchPolicy || 'cache-first',
        }).valueChanges.pipe(
            filter((result) => result.data != null),
            map((response) => response.data));
    }

    mutate<T = any, V = any>(mutation: DocumentNode, variables?: V): Observable<T> {
        return this.apollo.mutate<T, V>({
            mutation,
            variables,
            context: this.context,
        }).pipe(map(response => response.data as T));
    }

    refetchQueries(queryNames: string[]): void {
        this.apollo.client.refetchQueries({ include: queryNames });
    }

    private omitSkipTotalCount<V>(variables?: V): V | undefined {
        if (!variables || typeof variables !== "object") {
            return variables;
        }
        const record = variables as Record<string, unknown>;
        const input = record.input;
        if (!input || typeof input !== "object" || !("skipTotalCount" in input)) {
            return variables;
        }
        const rest = { ...(input as Record<string, unknown>) };
        delete rest.skipTotalCount;
        return { ...record, input: rest } as V;
    }
}
